/**
 * @generated SignedSource<<55b2797138ec756149e22ea74635add5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavLogoHamburger_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useNotificationsConfig_viewer">;
  readonly " $fragmentType": "NavLogoHamburger_viewer";
};
export type NavLogoHamburger_viewer$key = {
  readonly " $data"?: NavLogoHamburger_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavLogoHamburger_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavLogoHamburger_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useNotificationsConfig_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2f8cc16bd3b5d06f2442c90c751ac0ec";

export default node;
